export const DEFAULT_CSV_PARSE_OPTIONS = {
  bom: true,
  columns: false,
  delimiter: ',',
  skipEmptyLines: true,
};
